import { memo, useState, useEffect } from 'react';
import './style.scss';
import SidebarWrapper from '../SidebarWrapper';
import Router from '../../routes';
import { useLocation } from 'react-router-dom';
import mobileMenuIcon from '../../Images/Mobile_Header/menuIcon.svg';
import metaModelLogo from '../../Images/sidebar/Logo_MetaModel.svg';
import MobileMenu from '../MobileMenu';

const Layout = ({ user }) => {
  const [handleSideBar, setHandleSideBar] = useState(true);
  const [showSidebar, setShowSidebar] = useState(true);
  const [openMenu, setOpenMenu] = useState(false);
  const [showMobileHeader, setShowMobileHeader] = useState(true);
  let location = useLocation();

  const userDetails = JSON.parse(localStorage.getItem('mm:user'))?.userEmail;
  
  

  useEffect(() => {
    if (
      location.pathname.includes('signup') ||
      location.pathname.includes('login') ||
      location.pathname.includes('forgot') ||
      location.pathname.includes('admin-showcase') ||
      location.pathname.includes('digital-models')
    ) {
      setShowSidebar(false);
      setHandleSideBar(true);
      setShowMobileHeader(false);
    } else {
      setShowSidebar(true);
      setShowMobileHeader(true);
    }
    setOpenMenu(false);
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 600 && window.innerWidth <= 700) {
        setHandleSideBar(false);
      } else {
        setHandleSideBar(true);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [window]);

  const getPageContent = () => {
    return (
      <div
        className={
          showSidebar
            ? handleSideBar
              ? 'content_wrapper'
              : 'content_wrapper_large'
            : 'full_content_wrapper'
        }
      >
        {openMenu && getMobileMenu()}
        {showMobileHeader && getMobileHeader()}
        <div
          className={`content_router_wrapper ${
            showMobileHeader && 'content_router_wrap'
          }`}
        >
          <Router />
        </div>
      </div>
    );
  };

  const getSidebarPanel = () => {
    return (
      <div className={handleSideBar ? 'sidebar_wrapper' : 'hide_sidebar'}>
        <SidebarWrapper handleToggle={handleToggle} user={user} />
      </div>
    );
  };

  const handleToggle = () => {
    setHandleSideBar(!handleSideBar);
  };

  const handleMenuClick = () => {
    setOpenMenu(!openMenu);
  };

  const getMobileHeader = () => {
    return (
      <div className="mobile_header_wrapper">
        <div className="metamodel_logo_wrapper">
          {/* <img src={metaModelLogo} alt="metamodel_logo" /> */}
        </div>
        <div className="mobile_menu_wrapper">
          <img src={mobileMenuIcon} alt="menuIcon" onClick={handleMenuClick} />
        </div>
      </div>
    );
  };

  const getMobileMenu = () => {
    return (
      <div className="mobile_menu_main_container">
        <MobileMenu handleClose={() => setOpenMenu(!openMenu)} />
      </div>
    );
  };

  return (
    <div className={`layout_wrapper ${userDetails?.length > 0 ? 'layout_inner_wrapper' : ''}`}>
      {showSidebar && getSidebarPanel()}
      {getPageContent()}
    </div>
  );
};

export default memo(Layout);
